import { render, staticRenderFns } from "./SkillBasicInfo.vue?vue&type=template&id=d057fa4c&scoped=true&"
import script from "./SkillBasicInfo.vue?vue&type=script&lang=ts&"
export * from "./SkillBasicInfo.vue?vue&type=script&lang=ts&"
import style0 from "./SkillBasicInfo.vue?vue&type=style&index=0&id=d057fa4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d057fa4c",
  null
  
)

export default component.exports